import React from 'react';
import { LayoutList } from 'lucide-react';

const ItemsPerPageSelector = ({ value, onChange, options = [10, 20, 30, 40, 100] }) => {
  return (
    <div className="flex items-center">
      <div className="flex items-center gap-1.5 px-3 py-2 bg-white/50 border border-slate-200 rounded-xl hover:bg-white transition-all duration-300">
        <LayoutList size={16} className="text-slate-400" />
        <select
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          className="bg-transparent border-none outline-none text-sm font-medium text-slate-700 cursor-pointer focus:ring-0 p-0"
        >
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ItemsPerPageSelector;
